export default "__VITE_ASSET___HkS8jYj__"